import { useContext } from 'react';
import SloPeriodExpandedContext from './SloPeriodExpandedContext';

const withSloPeriodExpandedState = Component => props => {
  const sloPeriodExpanded = useContext(SloPeriodExpandedContext);
  return <Component expanded={sloPeriodExpanded} {...props} />;
};

export default withSloPeriodExpandedState;
